import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { memo, useMemo } from 'react';
import strings from '../../../Globalization';
import Gauge from '../../../components/common/charts/GaugeChart';


const GuageChart = ({ title, data }) => {
	const theme = useTheme();
	const leakTestMaxValue = data.leakTestMaxValue;
	return (
		<>
			<Box
				display={'flex'}
				alignItems={'center'}
				textAlign={'center'}
				sx={{
					borderTop: (theme) => `1px solid ${theme.palette.divider}`,
					borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
					padding: (theme) => theme.spacing(1)
				}}
			>
				<Typography variant="subtitle2" flex={1}>
					{title}
				</Typography>
			</Box>
			<Box display={'flex'} marginTop={2} alignItems={'center'} flexDirection={'column'}>
				<Typography textAlign={'center'} fontWeight={'bold'} variant="body2" gutterBottom>
					{strings.Pressure}
				</Typography>
				<Typography variant="subtitle2" flex={1}>
					{data.Unit}
				</Typography>
			</Box>
			<Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
				<Gauge
					min={data.Min}
					max={leakTestMaxValue}
					value={data.Value}
					tickCount={21}
					tickdecimals={2}
					startAngle={-90}
					endAngle={90}
					labelTickCount={5}
					pointerLabel={data.Unit}
					uom={data.Value}
					title={title}
					segments={[
						{
							min: data.Min,
							max: data.Max,
							color: theme.palette.error.light
						},
						{
							min: data.Max,
							max: leakTestMaxValue,
							color: theme.palette.success.light
						}
					]}
					gradient
				/>
			</Box>
		</>
	);
};

export default memo(GuageChart);